import React from 'react';
import { Reveal } from './Reveal';
import { Label } from './Label';
import { services } from '../data/site';
export function Services() {
  return <section id="work" className="w-full bg-cream py-20 sm:py-24" data-id="element-146" data-mp="1hwfdsocewlwg">
      <div className="mx-auto max-w-[960px] px-5 sm:px-8" data-id="element-147" data-mp="1dszo6byrflt9">
        <Reveal data-id="element-148" data-mp="18uy35lhrxcf5">
          <div className="flex items-center gap-3" data-id="element-149" data-mp="18vhay9dpmkfg">
            <span className="h-px w-10 bg-copper" data-id="element-150" data-mp="18x253xw441cs" />
            <Label data-id="element-151" data-mp="13w4o3omu9dcv">What I actually do</Label>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-px border border-navy/12 bg-navy/12 md:grid-cols-3" data-id="element-152" data-mp="z5ejidm8lej8">
          {services.map((service, i) => <Reveal key={service.title} delay={0.05 * i} className="flex flex-col bg-cream p-7 sm:p-8" data-id="element-153" data-mp="u6l4ggraxfgy" data-mpi={i}>
              <h3 className="font-serif text-[1.6rem] italic leading-[1.12] text-navy" data-id="element-154" data-mp="l5wqtn5tlh4l">
                {service.title}
              </h3>
              <p className="mt-5 font-sans text-sm font-light leading-relaxed text-navy/65" data-id="element-155" data-mp="g6siszumtpfu">
                {service.body}
              </p>
              <span aria-hidden="true" className="mt-auto block pt-8" data-id="element-156" data-mp="3b36bbms64eya">
                <span className="block h-px w-10 bg-copper/50" data-id="element-157" data-mp="3b4hgnr19huri" />
              </span>
            </Reveal>)}
        </div>
      </div>
    </section>;
}